<template>
    <article v-if="transaction" class="d-flex justify-content-between rounded bg-white">
        <h5 class="p-2 m-0"><Icon icon="hamburger" /> {{ transaction.merchant.name }}</h5>
        <p class="p-2 d-flex justify-content-end m-0">
            <time :datetime="transaction.transaction_at">{{ transaction.transaction_at | formatDate }}</time>
            <Badge color="success" small>Acceptée</Badge>
            <span>{{ transaction.amount }}</span>
        </p>
    </article>
</template>

<script>
    import Badge from '../Badge'
    import Icon from '../Icons/Icon'

    export default {
        name: 'CardTransaction',
        components: {
            Badge,
            Icon
        },
        props: {
            transaction: {
                type: Object,
                required: true
            }
        }
    }
</script>
